export const BRAND = { orange: "#F35A3A", dark: "#19242F" };

export const emptyHighlight = {
  id: "",
  icon: "star",
  title: "",
  description: "",
  imageUrl: "",
  imageAlt: "",
};
export const emptySlide = { url: "", alt: "", title: "", subtitle: "", position: "center" };
export const emptyBrand = { name: "", logoUrl: "", alt: "", query: "" };
export const emptyFont = { family: "", url: "", weight: "400", style: "normal", format: "woff2" };

function normalizeHighlightItems(source = []) {
  const seen = new Set();
  return (Array.isArray(source) ? source : []).map((item, index) => {
    const raw = String(item?.id || item?.title || `diferencial-${index + 1}`);
    const base =
      raw
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "") || `diferencial-${index + 1}`;
    let id = base;
    let suffix = 2;
    while (seen.has(id)) {
      id = `${base}-${suffix}`;
      suffix += 1;
    }
    seen.add(id);
    return { ...emptyHighlight, ...item, id, icon: item?.icon || "star" };
  });
}

export const emptySettings = {
  schemaVersion: 6,
  publicStatus: "draft",
  revision: 1,
  business: {
    name: "",
    shortDescription: "",
    whatsapp: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    province: "",
    country: "Argentina",
    schedule: "",
    mapEmbedUrl: "",
    socials: {
      instagram: "",
      facebook: "",
      tiktok: "",
      linkedin: "",
      youtube: "",
      website: "",
    },
  },
  navigation: {
    style: "style-1",
    homeUrl: "/",
    showAboutLink: true,
    aboutLabel: "Sobre nosotros",
    aboutUrl: "#about",
    showHighlightsLink: true,
    highlightsLabel: "Por qué elegirnos",
    highlightsUrl: "#highlights",
    productsUrl: "/productos",
    contactUrl: "/contact",
    loginUrl: "/login",
    showProductsLink: true,
    showContactLink: true,
    showCart: true,
    showCustomerAccess: true,
    showSocialLinks: true,
    homeLabel: "Inicio",
    productsLabel: "Productos",
    allProductsLabel: "Ver todos",
    contactLabel: "Contacto",
    loginLabel: "Iniciar sesión",
    accountLabel: "Mi cuenta",
    logoutLabel: "Cerrar sesión",
    cartLabel: "Ver carrito",
    cartTooltip: "Carrito",
    socialTitle: "Redes sociales",
    loadingCategoriesText: "Cargando categorías…",
    emptyCategoriesText: "No hay categorías todavía.",
    categoriesErrorText: "No se pudieron cargar las categorías.",
    menuAriaLabel: "Abrir menú",
    closeMenuAriaLabel: "Cerrar menú",
    cartAriaLabel: "Abrir carrito",
  },
  hero: {
    eyebrow: "",
    title: "",
    subtitle: "",
    primaryCtaLabel: "Consultar",
    primaryCtaUrl: "/contact",
    primaryCtaRequiresProducts: false,
    secondaryCtaLabel: "Ver productos",
    secondaryCtaUrl: "/productos",
    secondaryCtaRequiresProducts: true,
    imageUrl: "",
    imagePosition: "center",
    overlay: "linear-gradient(to bottom, rgba(0,0,0,.14), rgba(8,8,20,.72))",
    rotatingPhrases: [],
    slides: [],
  },
  catalog: {
    mode: "auto",
    brands: {
      eyebrow: "",
      title: "Marcas",
      subtitle: "Elegí una marca y explorá el catálogo disponible.",
      loadingText: "Cargando marcas…",
      emptyText: "Todavía no hay marcas para mostrar.",
      errorText: "No se pudieron cargar las marcas.",
      ctaLabel: "Ver productos",
      items: [],
    },
    spotlight: {
      enabled: false,
      eyebrow: "",
      title: "",
      description: "",
      logoUrl: "",
      logoAlt: "",
      backgroundImageUrl: "",
      ctaLabel: "",
      ctaUrl: "",
      ctaRequiresProducts: true,
      primaryColor: "#F35A3A",
      secondaryColor: "#19242F",
    },
    featured: {
      eyebrow: "",
      title: "Productos destacados",
      subtitle: "Conocé las últimas novedades del catálogo.",
      loadingText: "Cargando productos…",
      emptyText: "Todavía no hay productos para mostrar.",
      errorText: "No se pudieron cargar los productos.",
      ctaLabel: "Ver detalle",
    },
    categories: {
      eyebrow: "",
      title: "Explorá por categorías",
      subtitle: "",
      loadingText: "Cargando categorías…",
      emptyText: "Todavía no hay categorías para mostrar.",
      errorText: "No se pudieron cargar las categorías.",
      ctaLabel: "Ver productos",
      productSingular: "producto",
      productPlural: "productos",
    },
  },
  about: {
    eyebrow: "Sobre nuestro negocio",
    title: "Conocé nuestro negocio",
    description:
      "Trabajamos para ofrecer una atención cercana, soluciones claras y una experiencia confiable en cada consulta.",
    imageUrl: "",
    imageAlt: "Conocé nuestro negocio",
    layout: "image-left",
    imagePosition: "center",
    ctaLabel: "Contactanos",
    ctaUrl: "#contact",
    ctaRequiresProducts: false,
  },
  highlightsIntro: {
    eyebrow: "Por qué elegirnos",
    title: "Una experiencia pensada para vos",
    subtitle:
      "Combinamos atención, calidad y agilidad para que cada contacto con el negocio sea simple y confiable.",
  },
  highlights: [
    {
      id: "atencion-personalizada",
      icon: "support",
      title: "Atención personalizada",
      description: "Escuchamos cada necesidad y acompañamos al cliente de forma cercana.",
      imageUrl: "",
      imageAlt: "",
    },
    {
      id: "calidad-y-confianza",
      icon: "verified",
      title: "Calidad y confianza",
      description: "Cuidamos cada detalle para brindar una experiencia consistente y segura.",
      imageUrl: "",
      imageAlt: "",
    },
    {
      id: "respuesta-agil",
      icon: "speed",
      title: "Respuesta ágil",
      description: "Facilitamos la consulta y damos respuestas claras para avanzar sin vueltas.",
      imageUrl: "",
      imageAlt: "",
    },
  ],
  contact: {
    title: "Contacto",
    subtitle: "",
    whatsappMessage: "Hola, quiero hacer una consulta.",
    backgroundImageUrl: "",
    detailsCtaLabel: "Ver contacto",
    detailsCtaUrl: "/contact",
    whatsappCtaLabel: "Escribir por WhatsApp",
    floatingWhatsappAriaLabel: "Contactar por WhatsApp",
    mapTitle: "Ubicación",
  },
  footer: {
    style: "style-1",
    showLogo: true,
    tagline: "",
    copyright: "{businessName}. Todos los derechos reservados.",
    navigationTitle: "Navegación",
    contactTitle: "Contacto",
    homeLabel: "Inicio",
    productsLabel: "Productos",
    contactLabel: "Contacto",
  },
  messages: {
    maintenanceTitle: "Estamos actualizando el sitio",
    maintenanceDescription: "{businessName} se encuentra temporalmente en mantenimiento.",
    unavailableTitle: "Sitio no disponible",
    unavailableDescription: "La presencia pública de este proyecto todavía no está habilitada.",
    catalogDisabledTitle: "Catálogo no disponible",
    catalogDisabledDescription: "El catálogo no está habilitado para este sitio.",
    ordersDisabledTitle: "Pedidos no disponibles",
    ordersDisabledDescription: "Podés consultar el catálogo y comunicarte directamente con el comercio.",
    ecommerceDisabledTitle: "Pago online no disponible",
    ecommerceDisabledDescription: "El pedido puede coordinarse directamente con el comercio.",
  },
  appearance: {
    about: {
      backgroundColor: "",
      surfaceColor: "",
      accentColor: "",
      titleColor: "",
      textColor: "",
    },
    highlights: {
      backgroundColor: "",
      surfaceColor: "",
      accentColor: "",
      titleColor: "",
      textColor: "",
    },
    contact: {
      backgroundColor: "",
      surfaceColor: "",
      accentColor: "",
      titleColor: "",
      textColor: "",
    },
  },
  theme: {
    template: "catalog-basic",
    primaryColor: "#F35A3A",
    secondaryColor: "#19242F",
    surfaceColor: "#FFFFFF",
    backgroundColor: "#EEF0F5",
    textColor: "#1A1A2E",
    mutedTextColor: "#5B5D73",
    dividerColor: "rgba(26,26,46,.09)",
    logoUrl: "",
    compactLogoUrl: "",
    faviconUrl: "",
    fontFamily: "Asap",
    headingFontFamily: "Exo 2",
    bodyFontFamily: "Asap",
    googleFontsUrl: "",
    fonts: [],
    borderRadius: 10,
    mode: "light",
  },
  seo: {
    title: "",
    description: "",
    imageUrl: "",
  },
  sections: {
    showNavbar: true,
    showHero: true,
    showSpotlight: true,
    showBrands: true,
    showProducts: true,
    showFeatured: true,
    showCategories: true,
    showAbout: true,
    showHighlights: true,
    showContact: true,
    showFooter: true,
    showFloatingWhatsapp: true,
  },
};

export function mergeSettings(data) {
  const source = data || {};
  return {
    ...emptySettings,
    ...source,
    business: {
      ...emptySettings.business,
      ...(source.business || {}),
      socials: {
        ...emptySettings.business.socials,
        ...(source.business?.socials || {}),
      },
    },
    navigation: { ...emptySettings.navigation, ...(source.navigation || {}) },
    hero: {
      ...emptySettings.hero,
      ...(source.hero || {}),
      slides: Array.isArray(source.hero?.slides)
        ? source.hero.slides.map((slide) => ({ ...emptySlide, ...slide }))
        : [],
    },
    catalog: {
      ...emptySettings.catalog,
      ...(source.catalog || {}),
      brands: {
        ...emptySettings.catalog.brands,
        ...(source.catalog?.brands || {}),
        items: Array.isArray(source.catalog?.brands?.items)
          ? source.catalog.brands.items.map((item) => ({ ...emptyBrand, ...item }))
          : [],
      },
      spotlight: { ...emptySettings.catalog.spotlight, ...(source.catalog?.spotlight || {}) },
      featured: { ...emptySettings.catalog.featured, ...(source.catalog?.featured || {}) },
      categories: { ...emptySettings.catalog.categories, ...(source.catalog?.categories || {}) },
    },
    about: { ...emptySettings.about, ...(source.about || {}) },
    highlightsIntro: { ...emptySettings.highlightsIntro, ...(source.highlightsIntro || {}) },
    highlights: normalizeHighlightItems(
      Array.isArray(source.highlights) &&
      source.highlights.some(
        (item) => item?.title || item?.description || item?.imageUrl
      )
        ? source.highlights
        : emptySettings.highlights
    ),
    contact: { ...emptySettings.contact, ...(source.contact || {}) },
    footer: { ...emptySettings.footer, ...(source.footer || {}) },
    messages: { ...emptySettings.messages, ...(source.messages || {}) },
    appearance: {
      ...emptySettings.appearance,
      ...(source.appearance || {}),
      about: {
        ...emptySettings.appearance.about,
        ...(source.appearance?.about || {}),
      },
      highlights: {
        ...emptySettings.appearance.highlights,
        ...(source.appearance?.highlights || {}),
      },
      contact: {
        ...emptySettings.appearance.contact,
        ...(source.appearance?.contact || {}),
      },
    },
    theme: {
      ...emptySettings.theme,
      ...(source.theme || {}),
      fonts: Array.isArray(source.theme?.fonts)
        ? source.theme.fonts.map((font) => ({ ...emptyFont, ...font }))
        : [],
    },
    seo: { ...emptySettings.seo, ...(source.seo || {}) },
    sections: { ...emptySettings.sections, ...(source.sections || {}) },
  };
}

export const editorSections = [
  { id: "navbar", label: "Navbar" },
  { id: "hero", label: "Hero" },
  { id: "spotlight", label: "Spotlight" },
  { id: "featured", label: "Destacados" },
  { id: "brands", label: "Marcas" },
  { id: "categories", label: "Categorías" },
  { id: "about", label: "Sobre el negocio" },
  { id: "highlights", label: "Por qué elegirnos" },
  { id: "contact", label: "Contacto" },
  { id: "footer", label: "Footer" },
  { id: "floatingWhatsapp", label: "WhatsApp flotante" },
  { id: "identity", label: "Identidad" },
  { id: "seo", label: "SEO y estados" },
];

export function displayText(value, fallback) {
  return String(value || "").trim() || fallback;
}

export function resolveBusinessToken(value, businessName) {
  return displayText(value, "").replaceAll("{businessName}", displayText(businessName, "Tu negocio"));
}
